import type { Schemas } from "../api/client";

type Motion = Schemas["MotionAnalysis"];

/** The boxes of the analysed frame showing at `tMs` from the first video frame, if any. */
export function boxesAt(motion: Motion, tMs: number): number[][] {
  const frames = motion.boxes;
  let lo = 0;
  let hi = frames.length;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if ((frames[mid]?.t_ms ?? Infinity) <= tMs) lo = mid + 1;
    else hi = mid;
  }
  const f = frames[lo - 1];
  return f && tMs < f.t_ms + motion.frame_ms ? f.boxes : [];
}

/**
 * Where a video of `videoW` × `videoH` shows in a box of `w` × `h` with
 * `object-fit: contain`, as fractions of the box: `[x, y, width, height]`.
 */
export function contained(
  videoW: number,
  videoH: number,
  w: number,
  h: number,
): [number, number, number, number] {
  if (!videoW || !videoH || !w || !h) return [0, 0, 1, 1];
  const scale = Math.min(w / videoW, h / videoH);
  const cw = (videoW * scale) / w;
  const ch = (videoH * scale) / h;
  return [(1 - cw) / 2, (1 - ch) / 2, cw, ch];
}
